import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { rtkQueryErrorLogger } from './middlewares/apiErrorLogger';
import { xcoverAPI } from './services/xcover';
import tenantReducer from './slices/tenantSlice';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const store = configureStore({
  reducer: {
    [xcoverAPI.reducerPath]: xcoverAPI.reducer,
    tenant: tenantReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(xcoverAPI.middleware)
      .concat(rtkQueryErrorLogger),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
